import { render, staticRenderFns } from "./ApplicantListTemplate.vue?vue&type=template&id=01c49db1"
import script from "./ApplicantListTemplate.vue?vue&type=script&lang=ts"
export * from "./ApplicantListTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c49db1')) {
      api.createRecord('01c49db1', component.options)
    } else {
      api.reload('01c49db1', component.options)
    }
    module.hot.accept("./ApplicantListTemplate.vue?vue&type=template&id=01c49db1", function () {
      api.rerender('01c49db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ApplicantTemplate/ApplicantListTemplate.vue"
export default component.exports